import { TFunc, useTranslation } from 'libs/i18n';
import { TableColumn } from 'libs/ui';

import { renderDownload } from './renders/download';
import { renderName } from './renders/name';
import { renderSize } from './renders/size';
import { DocumentsColumnArgs, DocumentsListItem } from './types';

const getColumns = (
  t: TFunc,
  { onClickDownload, onClickPreview }: DocumentsColumnArgs
): TableColumn<DocumentsListItem>[] => [
  {
    field: 'name',
    title: t('account.documents.columns.name'),
    flex: 1,
    renderCell: (item) => renderName(item, t, () => onClickPreview(item)),
  },
  {
    field: 'size',
    title: t('account.documents.columns.size'),
    maxWidth: 200,
    minWidth: 200,
    renderCell: (item) => renderSize(item.size, t),
  },
  {
    field: 'download' as 'id',
    title: '',
    width: 56,
    align: 'center',
    renderCell: (item) => renderDownload(() => onClickDownload(item)),
  },
];

export const useColumns = (args: DocumentsColumnArgs) => {
  const { t } = useTranslation();
  const columns = getColumns(t, args);

  return columns;
};
